<template>
  <v-flex>
    <div class="d-flex justify-end mt-2" v-if="isAdmin">
      <template v-if="!isShowModify">
        <v-btn v-if="!isOrgData" class="button" outlined @click="showModify">
          수정
        </v-btn>
        <v-btn v-if="!isOrgData" class="button" outlined @click="isDeleteOrgData" :disabled="isMemberList">
          삭제
        </v-btn>
      </template>
      <template v-if="isShowModify">
        <v-btn class="button" outlined @click="isShowModify = false">취소</v-btn>
        <v-btn class="button" outlined @click="isModifyData">저장</v-btn>
      </template>
    </div>
    <v-container class="d-flex justify-center mx-auto">
      <v-row class="d-flex flex-column justify-start col-4">
        <v-col class="d-flex align-center">
          <v-col class=" text-h6 font-weight-bold" cols="5">부서명 : </v-col>
          <template>
            <span v-if="!isShowModify">
              {{ ((orgData.orgNm && !notTeamList.includes(orgData.orgNm)) ? orgData.orgNm + "팀" : orgData.orgNm) }}
            </span>
            <v-text-field
                v-if="isShowModify"
                v-model="modifyOrgData.orgNm"
                outlined hide-details dense
                background-color="white"
            />
          </template>
        </v-col>
        <v-col class="d-flex align-center">
          <v-col class=" text-h6 font-weight-bold" cols="5">조직장 : </v-col>
          <template>
            <span v-if="!isShowModify">{{ orgData.leaderNm }}</span>
            <v-select
              v-if="isShowModify"
              v-model="modifyOrgData.leaderId"
              :items="orgManagerList"
              placeholder="선택"
              item-text="text"
              item-value="value"
              outlined hide-details dense
              :background-color="orgManagerLength ? 'white' : 'grey lighten-2'"
              :disabled="!orgManagerLength"
            />
          </template>
        </v-col>
        <v-col class="d-flex align-center">
          <v-col class=" text-h6 font-weight-bold" cols="5">부서주소 : </v-col>
          <template>
            <span v-if="!isShowModify">{{ orgData.address }}</span>
            <v-text-field
                v-if="isShowModify"
                v-model="modifyOrgData.address"
                outlined hide-details dense
                background-color="white"
            />
          </template>
        </v-col>
        <v-col class="d-flex align-center">
          <v-col class=" text-h6 font-weight-bold" cols="5">생성일 : </v-col>
          <template>
            <span>{{ setTableDateFormat(orgData.createDate) }}</span>
          </template>
        </v-col>
        <v-col class="d-flex align-center">
          <v-col class=" text-h6 font-weight-bold" cols="5">정렬순서 : </v-col>
          <template>
            <span v-if="!isShowModify">{{ orgData.dispOrd }}</span>
            <v-text-field
                v-if="isShowModify"
                v-model="modifyOrgData.dispOrd"
                outlined hide-details dense
                background-color="white"
            />
          </template>
        </v-col>
        <v-col class="d-flex align-center">
          <v-col class=" text-h6 font-weight-bold" cols="5">상위부서명 : </v-col>
          <template>
            <span v-if="!isShowModify">{{ orgData.upperOrgNm }}</span>
            <search-group
                v-if="isShowModify"
                :search-nm="orgData.upperOrgNm"
                :items="orgList"
                @updateData="updateData"
            />
          </template>
        </v-col>
      </v-row>
    </v-container>
  </v-flex>
</template>

<script>
import DateMixin from "@/mixin/DateMixin";
import _ from "lodash";
import {axiosInstance} from "@/util/AxiosModule";
import TableMixin from "@/mixin/TableMixin";
import func from "@/util/func";
import {mapGetters} from "vuex";
import SearchGroup from "@/common/components/SearchGroup.vue";

export default {
  name: "OrgDataInfo",
  components: {SearchGroup},
  props: ["orgData"],
  mixins: [DateMixin, TableMixin],
  data() {
    return {
      isShowModify: false,
      notTeamList: ["인카모기지", "기획실", "에인"],
      modifyOrgData: {},
      orgList: [],
      orgManagerList: []
    }
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData",
      isAdmin: "isAdmin",
      memberId: "memberId"
    }),
    isOrgData() {
      return (_.isEmpty(this.orgData) || (this.orgData.orgNm === "인카모기지" || this.orgData.orgNm === "에인"));
    },
    isMemberList() {
      return this.orgData.memberCnt > 0;
    },
    orgManagerLength() {
      return this.orgManagerList.length > 0;
    }
  },
  watch: {
    orgData(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isShowModify = false;
        // this.getOrgList();
        // this.getOrgManagerList();
      }
    }
  },
  methods: {
    showModify() {
      this.isShowModify = true;
      this.modifyOrgData = _.cloneDeep(this.orgData);
      console.log("this.modifyOrgData: ", this.modifyOrgData);
      this.getOrgList();
      this.getOrgManagerList();
    },
    async getOrgList() {
      this.orgList = await func.getOrgList("", "Y", "N", "");
    },
    async getOrgManagerList() {
      const data = await func.getOrgList(this.orgData.orgCd, "Y", "Y", "MANAGER");
      this.orgManagerList = this.findTypeItem(data, "MANAGER");
    },
    findTypeItem(list, type) {
      let resultList = [];
      for (const item of list) {
        if (item.id !== "1000" && item.type === type) {
          resultList.push({text: item.name, value: item.id});
        }
        if (item.children && item.children.length) {
          const found = this.findTypeItem(item.children, type);
          if (found) {
            resultList = resultList.concat(found);
          }
        }
      }
      return resultList;
    },
    updateData(value) {
      this.modifyOrgData.upperOrgCd = value.id;
      this.modifyOrgData.upperOrgNm = value.name;
    },
    updateDate(value) {
      this.modifyOrgData.stDt = value;
    },
    isModifyData() {
      this.showConfirm({
        message: "부서정보를 수정하시겠습니까?",
        successCallback: () => {
          this.modifyData();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async modifyData() {
      const orgTb = this.modifyOrgData;
      orgTb.stDt = orgTb.stDt.replaceAll("-", "");
      orgTb.updateId = this.memberId;

      try {
        await axiosInstance.patch("/admin/org/org", orgTb)
            .then(() => {
              this.showAlert({
                message: "수정완료했습니다.",
                successCallback: () => {
                  this.isShowModify = false;
                  this.$emit("refresh");
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    isDeleteOrgData() {
      this.showConfirm({
        message: "부서를 삭제하시겠습니까?",
        successCallback: () => {
          this.deleteOrgData();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async deleteOrgData() {
      try {
        if (confirm()) {
          await axiosInstance.delete("/admin/org/org", {
            params: {
              memberId: this.memberId,
              orgCd: this.orgData.orgCd,
              useYn: "N"
            }
          }).then(() => {
            this.showAlert({
              message: "삭제완료되었습니다",
              successCallback: () => {
                this.$emit("refresh");
              }
            })
          })
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>